import getThemeStylesForTemplate from 'utils/tinyMCE/templates/getThemeStylesForTemplate'
import { formatCityStatePostal } from 'utils/tinyMCE/formatCityStatePostal'
import { escapeHtml } from '@messenger/utils'

export const finalRestingTemplate = ({
  editorProps,
  firstInsertion = false,
}) => {
  const { caseDetails, selectedTheme } = editorProps

  const {
    interment_place,
    interment_address,
    interment_city,
    interment_state,
    interment_postal_code,
  } = caseDetails

  const themeStyles = getThemeStylesForTemplate({
    selectedTheme,
    editor: editorProps.editor,
    firstInsertion,
  })

  const place = interment_place ? `<p>${escapeHtml(interment_place)}</p>` : ''
  const address = interment_address
    ? `<p>${escapeHtml(interment_address)}</p>`
    : ''

  // Build city/state/postal using smart comma placement utility
  const cityStatePostalString = formatCityStatePostal({
    city: interment_city,
    state: interment_state,
    postal: interment_postal_code,
  })

  const cityParagraph = cityStatePostalString
    ? `<p>${escapeHtml(cityStatePostalString)}</p>`
    : ''

  const html = `
    <div data-template="final_resting" class="mceNonEditable" style="${themeStyles}">
      ${place}
      ${address}
      ${cityParagraph}
    </div>
  `

  return html
}

export default finalRestingTemplate
